module.exports = __webpack_public_path__ + "static/couponImage-58b4d7a7bd8356353af67a385f257ebc.png";